<template>
  <div class="login-container" v-title data-title="登录">
    <div class="content-wrap">
      <div class="bg">
        <div class="info-wrap">
          <span class="welcome">欢迎登录</span>
          <span class="system-name">武汉市前期物业管理电子招投标系统</span>
        </div>
      </div>
      <div class="login-wrap">
        <LoginForm></LoginForm>
      </div>
    </div>
    <div class="login-footer">
      <div class="copyright">
        Copyright © 2018 采招云 | 鄂ICP备18026180号-1 |
        <img :src="badgeImg" alt="" />鄂公网安备 42010602003997号
      </div>
      <div class="company">运维单位：采招云（湖北）信息科技有限公司</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import LoginForm from './vue/loginForm.vue'

export default {
  props: {},
  components: {
    LoginForm,
  },
  data() {
    return {
      loginBgImg: require('./image/login-bg@2x.png'), // 登录背景图
      badgeImg: require('./image/badge@2x.png'), // 徽章
    }
  },
  computed: {},
  watch: {},
  methods: {},
  beforeCreate() {
    Vue.prototype.$loading = {
      show: () => {
        this.loading = true
      },
      hide: () => {
        this.loading = false
        this.loadingText = ''
      },
      text: (loadingText) => {
        this.loadingText = loadingText
      },
    }
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
.login-container {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #7cb3ff 0%, #4184f4 100%);
  padding: 70px 101px 0px;
  overflow: hidden;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  .content-wrap {
    width: 100%;
    min-width: 1200px;
    min-height: 660px;
    margin: 0px auto;
    padding: 0px 30px;
    display: flex;
    align-items: center;
    overflow: hidden;
    @media (max-width: 1600px) {
      min-height: 600px;
      .bg {
        font-size: 35px;
        min-height: 600px !important;
        .info-wrap {
          font-size: 35px;
        }
      }
      .login-wrap {
        min-height: 600px !important;
      }
    }
    .bg {
      flex: 1 1 58%;
      height: 100%;
      background-image: url('./image/login-bg@2x.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: relative;
      font-size: 50px;
      .info-wrap {
        position: absolute;
        top: 36px;
        left: 52px;
        display: flex;
        flex-direction: column;
        span {
          font-weight: bold;
          line-height: 70px;
          color: #496dff;
        }
      }
    }
    .login-wrap {
      flex: 1 1 42%;
      height: 100%;
    }
  }
  .login-footer {
    margin: 0px auto;
    width: 100%;
    min-width: 1200px;
    height: 170px;
    padding-top: 51px;
    display: flex;
    flex-direction: column;
    align-items: center;
    div {
      line-height: 34px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #fff;
      font-weight: 400;
      img {
        width: 22px;
        height: 23px;
        margin-left: 6px;
      }
    }
  }
}
</style>
